module.exports = __webpack_public_path__ + "static/media/file-alt.d498c602.svg";